import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import Breadcrumbs from '../../../../shared/library/breadcrumbs';

const Container = glamorous.div(
  {
    margin: '10px 0'
  },
  ({customStyle}) => (customStyle ? customStyle : {})
);

const ToolBreadcrumbs = ({tool, customStyle = {}, showHome = true, breadcrumbsStyle = {}}) => {
  const {layer, category} = tool;

  const items = [
    {name: 'Home', path: '/categories'},
    {name: layer.name, path: layer.slug},
    {name: category.name, path: category.slug},
    {name: tool.function.name, path: tool.function.slug}
  ];

  if (!showHome) items.shift();

  return (
    <Container customStyle={customStyle}>
      <Breadcrumbs items={items} customStyle={breadcrumbsStyle} />
    </Container>
  );
};

ToolBreadcrumbs.propTypes = {
  tool: PropTypes.object,
  customStyle: PropTypes.object,
  breadcrumbsStyle: PropTypes.object,
  showHome: PropTypes.bool
};

export default ToolBreadcrumbs;
